module.exports = __webpack_public_path__ + "9123d72dba7b190562e003e9d08a3c64.pdf";